import ReactPixel from 'react-facebook-pixel';
import Analytics from './Analytics';
import {useEffectOnce} from './useEffectOnce';
import {getValueFromSurveyData} from './getValueFromSurveyData';

export const useCheckoutScreenAnalytics = (variantName: string) => {
  useEffectOnce(() => {
    const referralCode = getValueFromSurveyData('referral_code');
    Analytics.track('InitiateCheckout', {
      checkoutVariant: variantName,
      referral_code: referralCode || undefined,
    });
    ReactPixel.track('InitiateCheckout');

    try {
      dataLayer.push({event: 'add_to_cart'});
    } catch (e) {
      // Silently handle missing dataLayer
    }
  });
};
